import axios from 'lib/axios';

import type {
  UsersResponse_Mock,
  UserResponse_Mock,
  ItemsResponse_Mock,
  PatchUserDto_Mock,
  PaginationParams,
  CurrentUserDetails_Mock,
} from 'types';

class UserService {
  async getCurrentUserDetails() {
    const response = await axios.get<CurrentUserDetails_Mock>(
      '/digitrack/me/details'
    );
    return response.data;
  }

  async getUsers(
    {
      start = 0,
      limit = 10,
      searchTerm,
    }: PaginationParams & {searchTerm?: string} = {start: 0, limit: 10}
  ) {
    const response = await axios.get<UsersResponse_Mock>('/users', {
      params:
        searchTerm && searchTerm.length > 0
          ? {
              searchTerm,
            }
          : undefined,
    });

    const {users = []} = response.data;

    return {
      count: Array.isArray(users) ? users.length : 0,
      records: Array.isArray(users) ? users.slice(start, start + limit) : [],
    };
  }

  async getUser(id: string) {
    const response = await axios.get<UserResponse_Mock>(`/users/${id}`);

    return response.data;
  }

  async editUser(id: string, patchUserDto: PatchUserDto_Mock) {
    const response = await axios.patch<UserResponse_Mock>(
      `/users/${id}`,
      patchUserDto
    );

    return response.data;
  }

  async getUserPostedItems({
    userId,
    start = 0,
    limit = 10,
  }: {userId: string} & PaginationParams) {
    const response = await axios.get<ItemsResponse_Mock>(
      `/users/${userId}/items`
    );

    const {items = []} = response.data;

    return {
      count: Array.isArray(items) ? items.length : 0,
      records: Array.isArray(items) ? items.slice(start, start + limit) : [],
    };
  }
}

export const userService = new UserService();
